import React, { useEffect } from "react";
import _ from "lodash";
import WizardPageLayout from "component-lib/WizardPageLayout";
import LoadingIndicator from "components/LoadingIndicator";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import moment from "moment";

import { dealGet } from "../../../deal/deal.store";
import LoansSelectionStep from "../loansSelectionStep";
import { actionCreators as reportDashboardActionCreators } from "../../dashboard/dashboard.store";

import { actionCreators as dscrSetupActionCreators } from "./dscrSetup.store";

const LenderReportsDscrSetup = props => {
  const {
    deal,
    match: {
      params: { dealId, reportId }
    },
    allDealLoans,
    getAllLoansForDeal,
    setDscrSetupSelections,
    reportComponentsForSelectedGroup,
    getReportComponentsForReportGroup,
    setDashboardSelections
  } = props;

  useEffect(()=>{
    setDashboardSelections({isProjected: false});
  },[]);
  useEffect(() => {
    if (_.isEmpty(deal)) {
      props.dealGet({ dealId });
    }
  }, [dealId, deal]);

  useEffect(() => {
    if (!reportComponentsForSelectedGroup) {
      getReportComponentsForReportGroup({ reportGroupId: reportId });
    }
  }, [reportId, reportComponentsForSelectedGroup]);

  useEffect(() => {
    if (!allDealLoans) {
      getAllLoansForDeal({ dealId });
    }
  }, [allDealLoans]);

  useEffect(() => {
    const dscrReportComponent = reportComponentsForSelectedGroup && reportComponentsForSelectedGroup
                                    .sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                    ?.find(comp => comp.type === "DSCR");
    
    if (dscrReportComponent && allDealLoans) {
      // set loans selected based on existing calculations
      const filteredLoans = allDealLoans.filter(loan => dscrReportComponent.calculations?.selectedLoans.find(l => l.id === loan.id));
      setDscrSetupSelections({
        dscrCalculations: dscrReportComponent.calculations.selectedLoans,
        selectedLoansForDSCR: filteredLoans,
        dscrReportComponent
      });
    }
  }, [reportComponentsForSelectedGroup, allDealLoans]);

  return <WizardPageLayout cardComponent={deal ? <LoansSelectionStep {...props} componentType="DSCR" /> : <LoadingIndicator />} />;
};

const mapStateToProps = ({ newDeal: { deal }, authentication: { user }, lenderReportsDscrSetup, lenderReportList }) => ({
  deal,
  user,
  ...lenderReportsDscrSetup,
  ...lenderReportList
});
const mapDispatchToProps = dispatch => bindActionCreators({ dealGet, ...dscrSetupActionCreators, ...reportDashboardActionCreators }, dispatch);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LenderReportsDscrSetup);
